// Outils partagés de la page Clients (liste, fiche, formulaire).

// Nom affiché d'un client : prénom + nom, sinon société, email ou téléphone (fiches incomplètes
// venues d'un module qui ne demande pas le nom).
export const customerName = (customer) => {
  if (!customer) return '';
  const fullName = [customer.firstName, customer.lastName].filter(Boolean).join(' ').trim();
  return fullName || customer.companyName || customer.email || customer.phone || '';
};

export const customerInitials = (customer) => {
  const source = [customer?.firstName, customer?.lastName].filter(Boolean);
  const words = source.length ? source : (customerName(customer) || '?').split(/\s+/);
  return words.slice(0, 2).map(word => word.charAt(0)).join('').toUpperCase() || '?';
};

// Couleur d'avatar stable par client (même client = même couleur d'une visite à l'autre).
const AVATAR_COLORS = ['#2A6FDB', '#16A34A', '#9333EA', '#EA580C', '#0891B2', '#DB2777', '#4F46E5', '#CA8A04'];
export const avatarColor = (id) => AVATAR_COLORS[Math.abs(Number(id) || 0) % AVATAR_COLORS.length];

export const formatMoney = (value, currency) => {
  try {
    return new Intl.NumberFormat(navigator.language, {style: 'currency', currency: currency || 'EUR'}).format(value || 0);
  } catch (e) {
    return `${(value || 0).toFixed(2)} ${currency || ''}`.trim();
  }
};

export const formatDate = (epochMillis, locale) => (epochMillis
  ? new Intl.DateTimeFormat(locale || navigator.language, {day: '2-digit', month: '2-digit', year: 'numeric'}).format(new Date(epochMillis))
  : null);

// Pays : code ISO (saisie dashboard) traduit dans la langue du chauffeur, ou texte libre (widget) tel quel.
export const countryLabel = (country, locale) => {
  if (!country) return '';
  if (/^[A-Za-z]{2}$/.test(country) && typeof Intl.DisplayNames === 'function') {
    try {
      return new Intl.DisplayNames([locale || 'fr'], {type: 'region'}).of(country.toUpperCase()) || country;
    } catch (e) {
      return country;
    }
  }
  return country;
};

export const formattedAddress = (customer) => {
  if (!customer) return '';
  const cityLine = [customer.postalCode, customer.city].filter(Boolean).join(' ');
  return [customer.address, customer.addressComplement, cityLine].filter(Boolean).join(', ');
};

// Recherche insensible aux accents et à la casse ; le téléphone se cherche aussi chiffres seuls
// (« 0612 » trouve « 06 12 34 56 78 »).
export const normalizeText = (value) => (value || '')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .trim();

export const matchesCustomer = (customer, query) => {
  const normalizedQuery = normalizeText(query);
  if (!normalizedQuery) return true;
  if (customer.locked) return false;
  const haystack = normalizeText([
    customer.firstName, customer.lastName, customer.companyName, customer.email, customer.phone, customer.city,
  ].filter(Boolean).join(' '));
  if (normalizedQuery.split(/\s+/).every(word => haystack.includes(word))) return true;
  const digits = normalizedQuery.replace(/\D/g, '');
  return digits.length >= 3 && (customer.phone || '').replace(/\D/g, '').includes(digits);
};
